<script setup>
import {useRoute} from "vue-router";
import {ref} from "vue";
import { usePlayerStore } from '@/stores/playerStore';

import userService from "@/stores/user";
const route = useRoute();
const token = route.query.token
const loading = ref(true);
const playerStore = usePlayerStore();

const getData = async () => {
  try {
    const response = await userService.getInfo(token);

    if (response) {
      const user = response.data;
      localStorage.setItem('user', JSON.stringify(user));
      localStorage.setItem('player', JSON.stringify(user.player));
      playerStore.setUser(user);
      window.location.href = '/trang-chu';
    }
  } catch (error) {
    console.log(error);
  }
}

getData().then(() => {
  loading.value = false;
})
</script>
<template>
  <div class="authendication-pages">
    <div v-if="loading" class="data_loading_">
      <div class="spinner-border text-white" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <!-- Page Content -->
    <div class="content">
      <div class="container wrapper no-padding">
        <div class="row no-margin vph-100">
          <div class="col-12 no-padding">
            <div class="banner-bg login" style="width: 100%">
              <div class="row no-margin h-100">
                <div class="col-sm-10 col-md-10 col-lg-10 mx-auto">
                  <div
                      class="h-100 d-flex justify-content-center align-items-center"
                  >
                    <div class="text-bg register text-center">
                      <button
                          class="btn btn-limegreen text-capitalize"
                          type="button"
                      >
                        <i class="fa-solid fa-thumbs-up me-3"></i>Đang đăng nhập
                      </button>
                      <p>
                        Để quản lý thông tin vận động viên và thứ hạng của mình,
                        vui lòng đăng nhập vào hệ thống.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- /Page Content -->
  </div>
</template>
<style scoped>
.data_loading_ {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
}

.menu-opened body:before {
  display: none;
}
</style>